<script setup lang="ts">
import type { Study } from '~/utils/generated/graphql'

function showAuthPrompt() {
  window.dispatchEvent(new Event('show-auth-prompt'))
}

defineProps<{
  study: Study
  index: number
}>()
</script>

<template>
  <div class="border bg-blurple-100 p-8 mt-6 text-center rounded-lg">
    <h2 class="h3 p-0 m-0">
      {{ $t('sayOnTrackWithPassionEquip') }}
    </h2>
    <p class="p text-gray-500 mt-2">
      {{ $t('trackProgress') }}
    </p>
    <div>
      <PLink
        id="study-create-account-link"
        :content="[{ id: study.id, type: 'Study', index: index }, { id: study.session?.id || '', type: 'StudySession', index: index }]"
        :extras="{ slug: study.slug }"
        href="#"
        :click="showAuthPrompt"
        class="bg-[#3531ED] rounded-lg px-16 py-2 text-white hover:bg-blurple-900 text-base no-underline"
      >
        {{ $t('createAProfile') }}
      </PLink>
    </div>
  </div>
</template>
